// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-container {
    min-height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
    padding: 2rem;
}

.login-card {
    background: white;
    border-radius: 1rem;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
    width: 100%;
    max-width: 400px;
    padding: 2rem;
    text-align: center;
}

.login-header {
    margin-bottom: 2rem;
}

.login-header h1 {
    color: #1a1a1a;
    font-size: 2rem;
    font-weight: 600;
    margin-bottom: 0.5rem;
}

.login-header p {
    color: #6b7280;
    font-size: 1rem;
}

.login-content {
    margin-bottom: 2rem;
}

.google-login-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.75rem;
    width: 100%;
    padding: 0.875rem 1.5rem;
    background: #fff;
    border: 1px solid #e5e7eb;
    border-radius: 0.5rem;
    color: #1a1a1a;
    font-size: 1rem;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s ease;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
}

.google-login-btn:hover {
    background: #f9fafb;
    border-color: #d1d5db;
    transform: translateY(-1px);
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
}

.google-login-btn:disabled {
    opacity: 0.7;
    cursor: not-allowed;
    transform: none;
}

.google-icon {
    color: #ea4335;
    font-size: 1.25rem;
}

.error-message {
    margin-top: 1rem;
    padding: 0.75rem;
    background: #fee2e2;
    border: 1px solid #ef4444;
    border-radius: 0.5rem;
    color: #b91c1c;
    font-size: 0.875rem;
}

.login-footer {
    color: #6b7280;
}

.login-footer p {
    margin-bottom: 0.5rem;
    font-size: 0.875rem;
}

.login-footer small {
    font-size: 0.75rem;
}

/* Responsive adjustments */
@media (max-width: 640px) {
    .login-container {
        padding: 1rem;
    }

    .login-card {
        padding: 1.5rem;
    }

    .login-header h1 {
        font-size: 1.75rem;
    }
}`, "",{"version":3,"sources":["webpack://./src/pages/Login.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,6DAA6D;IAC7D,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,iFAAiF;IACjF,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,WAAW;IACX,wBAAwB;IACxB,gBAAgB;IAChB,yBAAyB;IACzB,qBAAqB;IACrB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,2CAA2C;AAC/C;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,2BAA2B;IAC3B,iFAAiF;AACrF;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,yBAAyB;IACzB,qBAAqB;IACrB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA,2BAA2B;AAC3B;IACI;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,kBAAkB;IACtB;AACJ","sourcesContent":[".login-container {\n    min-height: 100vh;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);\n    padding: 2rem;\n}\n\n.login-card {\n    background: white;\n    border-radius: 1rem;\n    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);\n    width: 100%;\n    max-width: 400px;\n    padding: 2rem;\n    text-align: center;\n}\n\n.login-header {\n    margin-bottom: 2rem;\n}\n\n.login-header h1 {\n    color: #1a1a1a;\n    font-size: 2rem;\n    font-weight: 600;\n    margin-bottom: 0.5rem;\n}\n\n.login-header p {\n    color: #6b7280;\n    font-size: 1rem;\n}\n\n.login-content {\n    margin-bottom: 2rem;\n}\n\n.google-login-btn {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 0.75rem;\n    width: 100%;\n    padding: 0.875rem 1.5rem;\n    background: #fff;\n    border: 1px solid #e5e7eb;\n    border-radius: 0.5rem;\n    color: #1a1a1a;\n    font-size: 1rem;\n    font-weight: 500;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n}\n\n.google-login-btn:hover {\n    background: #f9fafb;\n    border-color: #d1d5db;\n    transform: translateY(-1px);\n    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);\n}\n\n.google-login-btn:disabled {\n    opacity: 0.7;\n    cursor: not-allowed;\n    transform: none;\n}\n\n.google-icon {\n    color: #ea4335;\n    font-size: 1.25rem;\n}\n\n.error-message {\n    margin-top: 1rem;\n    padding: 0.75rem;\n    background: #fee2e2;\n    border: 1px solid #ef4444;\n    border-radius: 0.5rem;\n    color: #b91c1c;\n    font-size: 0.875rem;\n}\n\n.login-footer {\n    color: #6b7280;\n}\n\n.login-footer p {\n    margin-bottom: 0.5rem;\n    font-size: 0.875rem;\n}\n\n.login-footer small {\n    font-size: 0.75rem;\n}\n\n/* Responsive adjustments */\n@media (max-width: 640px) {\n    .login-container {\n        padding: 1rem;\n    }\n\n    .login-card {\n        padding: 1.5rem;\n    }\n\n    .login-header h1 {\n        font-size: 1.75rem;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
